import { graphql } from '../../generated';

export const TICKET_FRAGMENT = graphql(`
  fragment PrintedTicketFragment on PrintedTicket {
    id
    validationCode
    comment
    user {
      name
      email
    }
    pricingCategoryName
    orderedAt
    total
    personalIdentifier
    invalidated
    productVariantDescription
    url
    venueSectionId
    seat {
      id
      name
      row
      venueSection {
        id
        name
      }
    }
    order {
      user {
        name
        email
      }
      tags
    }
  }
`);

export const EVENT_PRINTED_TICKETS = graphql(`
  query EventPrintedTicketsQuery($id: ID!) {
    event(id: $id) {
      id
      printedTickets {
        ...PrintedTicketFragment
      }
    }
  }
`);

export const PRINT_TICKETS = graphql(`
  mutation PrintTickets(
    $seatIds: [ID!]
    $productVariantId: ID!
    $comment: String!
    $pool: String
    $amount: Int
    $sectionId: ID
    $email: String
    $tags: [String!]
    $name: String
    $lastName: String
    $personalIdentifier: String
  ) {
    printTickets(
      input: {
        seatIds: $seatIds
        productVariantId: $productVariantId
        comment: $comment
        pool: $pool
        count: $amount
        sectionId: $sectionId
        email: $email
        tags: $tags
        firstName: $name
        lastName: $lastName
        personalIdentifier: $personalIdentifier
      }
    ) {
      clientMutationId
    }
  }
`);

export const CONTINGENT = graphql(`
  query ContingentQuery($id: ID!, $sectionId: ID!) {
    event(id: $id) {
      id
      contingent(sectionId: $sectionId) {
        capacity
        valid
        reserved
        cart
        available
        blocked
        pools {
          name
          count
        }
      }
    }
  }
`);

export const ALLOCATION = graphql(`
  query AllocationQuery($id: ID!, $generalAdmissionOnly: Boolean!) {
    event(id: $id) {
      id
      allocation(generalAdmissionOnly: $generalAdmissionOnly) {
        section {
          id
          name
        }
        capacity
        available
        systemFree
        systemSold
        processing
        local
        reserved
        cart
        blocked
        blockedSeats {
          id
          blockReason
          seat {
            id
            name
            row
          }
        }
      }
    }
  }
`);

export const SHIFT_CONTINGENT = graphql(`
  mutation ShiftContingent($eventId: ID!, $sectionId: ID!, $pool: String, $blockReason: String, $amount: Int!) {
    changeContingent(
      input: { eventId: $eventId, sectionId: $sectionId, amount: $amount, blockReason: $blockReason, pool: $pool }
    ) {
      clientMutationId
    }
  }
`);

export const CHANGE_CAPACITY = graphql(`
  mutation ChangeCapacity($eventId: ID!, $sectionId: ID!, $blockReason: String, $amount: Int!) {
    changeCapacity(input: { eventId: $eventId, sectionId: $sectionId, amount: $amount, blockReason: $blockReason }) {
      clientMutationId
    }
  }
`);

export const RETURN_TICKETS = graphql(`
  mutation ReturnTickets($itemIds: [ID!]!, $blockReason: String) {
    returnPrintedTickets(input: { itemIds: $itemIds, blockReason: $blockReason }) {
      clientMutationId
    }
  }
`);

export const UPDATE_PERSONALIZATION = graphql(`
  mutation TicketPersonalization($itemId: ID!, $personalIdentifier: String!) {
    updatePersonalization(input: { itemId: $itemId, personalIdentifier: $personalIdentifier }) {
      ticket {
        id
        personalIdentifier
      }
    }
  }
`);

export const POLL_TICKETS = graphql(`
  query EventPrintedTicketsPollingQuery($eventId: ID!, $ticketIds: [ID!]!) {
    event(id: $eventId) {
      id
      printedTickets(ids: $ticketIds) {
        ...PrintedTicketFragment
      }
    }
  }
`);

export const GET_EVENT_SCANNER_NAMES = graphql(`
  query GetEventScannerNames($eventId: ID!) {
    event(id: $eventId) {
      id
      scannerNames
    }
  }
`);

export const UPDATE_EVENT_SCANNER_NAMES = graphql(`
  mutation UpdateEventScannerNames($scannerNames: [String!]!, $eventId: ID!) {
    updateScannerNames(input: { scannerNames: $scannerNames, eventId: $eventId }) {
      event {
        id
        scannerNames
      }
    }
  }
`);

export const GET_EVENT_SCANNER_CODE_TYPES = graphql(`
  query GetEventScannerCodeTypes($eventId: ID!) {
    event(id: $eventId) {
      id
      scannerCodeTypes
    }
  }
`);

export const UPDATE_EVENT_SCANNER_CODE_TYPES = graphql(`
  mutation UpdateEventScannerCodeTypes($eventId: ID!, $scannerCodeTypes: [EventScannerCodeType!]!) {
    updateEventScannerCodeTypes(input: { eventId: $eventId, scannerCodeTypes: $scannerCodeTypes }) {
      event {
        id
        scannerCodeTypes
      }
    }
  }
`);
